import React, { FunctionComponent, useState } from 'react';
import messages from './Messages';
import { ProjectMembersListWrapper } from './styles';
import Select from '../../../components/Select';
import { Item } from './styles';
import { IOption } from '../../../components/Select/Select';
import Input from '../../../components/Input/Input';
import { green, orange, red } from '../../../utils/style/colors';
import Button from '../../../components/Button/Button';
import ActionLink from '../../../components/ActionLink/ActionLink';
import Icon from '../../../components/Icon/Icon';
import { BatchAddItem } from './ProjectMembers';
import { IUser, IUsers } from 'store/users/usersType';
import { ICompanyMember, ICompanyRole } from 'store/companies/companiesTypes';

interface IOwnProps {
  projectUsers: IUsers['map'];
  projectRoles: ICompanyRole[];
  roles: { [key: number]: ICompanyRole };
  newUsers: BatchAddItem[];
  users: IUsers['map'];
  onUpdateNewUsers: (users: BatchAddItem[]) => void;
  companyMembers: { [keys: number]: ICompanyMember };
  addOrUpdateNewMembers: (
    isAdmin: boolean,
    canCreate: boolean,
    visibleAllTask: boolean
  ) => Promise<any>;
}

type IComponentProps = IOwnProps;

const ProjectsMemberBatchAdd: FunctionComponent<IComponentProps> = ({
  onUpdateNewUsers,
  addOrUpdateNewMembers,
  projectUsers,
  projectRoles,
  newUsers,
  users,
  companyMembers,
  roles,
}) => {
  const [loading, setLoading] = useState(false);
  const [isAdmin, setAdmin] = useState(false);
  const [visibleAllTask, setVisibleAllTask] = useState(false);
  const [canCreate, setCanCreate] = useState(false);

  const companyUsers = Object.values(users)
    .filter(
      (user) => !companyMembers[user.id].inactive
      // Object.values(companyMembers).find(
      //   (v, k) => k === user.id && !v!.inactive
      // )
    )
    .reduce((usersList: IOption[], user: IUser) => {
      usersList.push({
        label: user.name,
        value: user.id,
      });
      return usersList;
    }, []);

  const companyRoles = Object.values(roles).reduce(
    (roleList: any, role: ICompanyRole | undefined) => {
      if (role?.isProjectRole) return roleList;
      roleList.push({
        label: role!.name!,
        value: role!.id!,
      });
      return roleList;
    },
    [] as IOption[]
  );
  const companyProjectRoles = Object.values(roles).reduce(
    (usersList: any, role: ICompanyRole | undefined) => {
      if (!role?.isProjectRole) return usersList;
      usersList.push({
        label: role!.name!,
        value: role!.id!,
      });
      return usersList;
    },
    [] as IOption[]
  );

  const onSelectUser = (usersOptions: IOption[], index: number) => {
    const updated = [...newUsers];
    if (usersOptions.length > 0) {
      updated[index].user = users[Number(usersOptions[0].value)];
    }
    onUpdateNewUsers(updated);
  };
  const onSelectRole = (rolesOptions: IOption[], index: number) => {
    const updated = [...newUsers];
    if (rolesOptions.length > 0) {
      updated[index].relatedRole = roles[Number(rolesOptions[0].value)];
      if (roles[Number(rolesOptions[0].value)].users.length > 1)
        updated[index].addRole = false;
    } else {
      updated[index].relatedRole = undefined;
      updated[index].addRole = false;
    }
    onUpdateNewUsers(updated);
  };
  const handleChangeFlag = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
    flag: string
  ) => {
    const updated = [...newUsers];
    updated[index][flag] = e.target.checked;
    onUpdateNewUsers(updated);
  };
  const onSelectProjectRole = (rolesOptions: IOption[], index: number) => {
    const updated = [...newUsers];
    if (rolesOptions.length > 0) {
      updated[index].projectRole = roles[Number(rolesOptions[0].value)];
    } else {
      updated[index].projectRole = undefined;
    }
    onUpdateNewUsers(updated);
  };

  /*const onChangeTitle = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const updated = [...newUsers];
    updated[index].title = e.target.value;
    onUpdateNewUsers(updated);
  };*/
  const onRemove = (index: number) => {
    const updated = [...newUsers];
    updated.splice(index, 1);
    onUpdateNewUsers(updated);
  };

  const submit = () => {
    setLoading(true);
    return addOrUpdateNewMembers(isAdmin, canCreate, visibleAllTask).then(
      () => {
        setLoading(false);
      },
      () => {
        setLoading(false);
      }
    );
  };
  return (
    <ProjectMembersListWrapper>
      {newUsers.map((newUser, index) => {
        let message = messages.pleaseSpecifyUser;
        const userRoles = companyMembers[newUser.user?.id || -1]?.roles;
        let color = red;
        if (newUser.user) {
          if (projectUsers[newUser.user.id]) {
            color = orange;
            message = messages.alreadyExists;
          } else {
            color = green;
            message = messages.willBeAdded;
          }
        }
        if (newUser.addRole) {
          if (projectRoles.find((it) => it.id === newUser.relatedRole!.id)) {
            color = orange;
            message = messages.roleExistInProject;
          } else {
            color = green;
            message = messages.roleWillBeAdded;
          }
        }
        return (
          <Item key={index} className="row">
            <span className="col m1">
              <ActionLink onClick={() => onRemove(index)}>
                <Icon type="trash-2" color={red} />
              </ActionLink>
            </span>
            <span className="col m3">
              <Select
                onChangeValues={(values) => onSelectUser(values, index)}
                values={
                  newUser.user
                    ? [
                        {
                          value: newUser.user.id,
                          label: newUser.user.name,
                        },
                      ]
                    : []
                }
                label={messages.companyMember + ' - ' + newUser.name}
                options={companyUsers}
                placeholder={messages.selectMember}
              />
            </span>
            <span className="col m3">
              <Select
                onChangeValues={(values) => onSelectRole(values, index)}
                values={
                  newUser.relatedRole
                    ? [
                        {
                          value: newUser.relatedRole.id,
                          label: newUser.relatedRole.name,
                        },
                      ]
                    : []
                }
                label={
                  messages.relatedRole +
                  ' - ' +
                  (newUser.relatedRoleTitle || '')
                }
                options={companyRoles.filter((it: IOption) => {
                  return !userRoles || userRoles[it.value.toString()];
                })}
                placeholder={messages.relatedRole}
              />
              <div>
                {newUser.relatedRole &&
                  messages.memberCount(newUser.relatedRole.users.length)}
                <br />
                {newUser.relatedRole &&
                  newUser.relatedRole?.users?.length === 1 &&
                  users[newUser?.relatedRole?.users?.[0]?.userId || -1]?.name}
              </div>
              {newUser?.relatedRole &&
                (newUser?.relatedRole?.users?.length || 0) <= 1 && (
                  <Input
                    id={index + 'addAsRole'}
                    type="checkbox"
                    checked={newUser.addRole}
                    onChange={(e) => handleChangeFlag(e, index, 'addRole')}
                    label={messages.addAsRole}
                  />
                )}
            </span>
            <span className="col m2">
              <Select
                onChangeValues={(values) => onSelectProjectRole(values, index)}
                values={
                  newUser.projectRole
                    ? [
                        {
                          value: newUser.projectRole.id,
                          label: newUser.projectRole.name,
                        },
                      ]
                    : []
                }
                label={messages.projectRole + ' - ' + (newUser.title || '')}
                options={companyProjectRoles}
                placeholder={messages.projectRole}
              />
            </span>
            <div className="col m4">
              <span key="admin" className="row">
                <Input
                  checked={newUser.isAdmin}
                  id={'isAdmin' + index}
                  label={messages.admin}
                  name="isAdmin"
                  onChange={(e) => handleChangeFlag(e, index, 'isAdmin')}
                  type="checkbox"
                />
              </span>
              <span key="canCreate" className="row">
                <Input
                  checked={newUser.canCreate}
                  id={'canCreate' + index}
                  label={messages.canCreate}
                  name="canCreate"
                  onChange={(e) => handleChangeFlag(e, index, 'canCreate')}
                  type="checkbox"
                />
              </span>
              <span key="visibleAllTask" className="row">
                <Input
                  checked={newUser.visibleAllTasks}
                  id={'visibleAllTask' + index}
                  label={messages.visibleAllTasks}
                  name="visibleAllTask"
                  onChange={(e) =>
                    handleChangeFlag(e, index, 'visibleAllTasks')
                  }
                  type="checkbox"
                />
              </span>
            </div>
            <span className="col m4" style={{ color }}>
              {message}
            </span>
          </Item>
        );
      })}
      <Item className="row ">
        <span className="col m2">{messages.applyToAll} </span>
        <span key="admin" className="col m3">
          <Input
            checked={isAdmin}
            id="isAdmin"
            label={messages.admin}
            name="isAdmin"
            onChange={(e) => setAdmin(e.target.checked)}
            type="checkbox"
          />
        </span>
        <span key="canCreate" className="col m3">
          <Input
            checked={canCreate}
            id="canCreate"
            label={messages.canCreate}
            name="canCreate"
            onChange={(e) => setCanCreate(e.target.checked)}
            type="checkbox"
          />
        </span>
        <span key="visibleAllTask" className="col m3">
          <Input
            checked={visibleAllTask}
            id="visibleAllTask"
            label={messages.visibleAllTasks}
            name="visibleAllTask"
            onChange={(e) => setVisibleAllTask(e.target.checked)}
            type="checkbox"
          />
        </span>
        <span className="col m1">
          <Button color="green" onClick={submit} loading={loading}>
            {messages.submit}
          </Button>
        </span>
      </Item>
    </ProjectMembersListWrapper>
  );
};

export default ProjectsMemberBatchAdd;
